import general from './general';
import smoothScroll from 'smooth-scroll';
import debounce from 'lodash/debounce';
import delay from 'lodash/delay';
import map from 'lodash/map';
import inRange from 'lodash/inRange';
import verge from 'verge';


const
    isMobile = general.isMobileDevice(),
    inPage = 'in-page',
    hidden = 'hidden',
    winHeight = window.innerHeight,
    menuOffsetLimit = (winHeight - 10),
    //buffer = Math.round(winHeight * 0.5),
    speed = 450,
    easing = 'easeInOutElastic',
    hashLinks = 'a[href*="#"]',
    doc = document.documentElement;

let
    rtn = {},
    arrow,
    backToTop,
    pagination,
    popup,
    scroll,
    currentBraceCollection,
    currentBrace,
    nextBrace,
    colorClassname,
    isScrolling;





/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
const scrollEventHandler = (event) => {

    switch (event.type) {

        case 'scrollStart':
            //do nothing;
            break;

        case 'scrollStop':
            map(currentBraceCollection, getCurrent);
            updateStyling();
            break;

        case 'scroll':
            // Clear our timeout throughout the scroll
            window.clearTimeout(isScrolling);
            // Set a timeout to run after scrolling ends
            isScrolling = setTimeout(() => {
                map(currentBraceCollection, getCurrent);
                updateStyling();
            }, 500);
            break;

    }
};



/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
const getCurrent = (el) => {

    const
        scrollPos = verge.scrollY();
        //elTop = el.offsetTop - buffer,
        //elHeight = (elTop + el.scrollHeight);


    //if a brace is in the viewport set it to current
    /*if (inRange(scrollPos, elTop, elHeight)) {

        //console.log(scrollPos, elTop, elHeight, el.id);

        currentBrace = el;
        //console.log(currentBrace);
        if (!currentBrace.nextElementSibling) {
            nextBrace = null;
        } else {
            nextBrace = currentBrace.nextElementSibling.id;
        }

        return false;

    }*/

    if (verge.inY(el, -200)) {
        currentBrace = el;
        if (!currentBrace.nextElementSibling) {
            nextBrace = null;
        } else {
            nextBrace = currentBrace.nextElementSibling.id;
            //console.log(currentBrace, nextBrace);
        }
        return false;
    }

    //update document body class if in page
    if (scrollPos > menuOffsetLimit) {
        document.body.classList.add(inPage);
    } else {
        document.body.classList.remove(inPage);
    }

}

/**
 * @brief [brief description]
 * @details [long description]
 * @return [description]
 */
const scrollToBrace = (brace) => {
    const scroll = new smoothScroll();
    scroll.animateScroll(brace, null, {
        speed: speed,
        easing: easing
    });
}


/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
const arrowEvent = (e) => {
    e.preventDefault();
    if (nextBrace) {
        scrollToBrace(document.getElementById(nextBrace));
    }
}

/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
const setDatasetColor = (elementCollection) => {

    if (NodeList.prototype.isPrototypeOf(elementCollection)) {
        map(elementCollection, (e) => {
            e.dataset.color = colorClassname;
        })
    } else {
        if (elementCollection) {
            elementCollection.dataset.color = colorClassname;
        }

    }
}




/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
const updateStyling = () => {

    if (currentBrace) {

        const braceBG = general.getStyle(currentBrace, 'background-color');
        colorClassname = general.getContrastYIQ(braceBG);

        //change the dataset colour of specific elements
        setDatasetColor(popup);
        setDatasetColor(pagination);

        //if not first brace show the back to top button
        if (general.indexOf(currentBraceCollection, currentBrace) > 0) {
            backToTop.classList.remove(hidden);
        } else {
            backToTop.classList.add(hidden);
        }

        //if a next brace id exists show the arrow button
        if (nextBrace) {
            arrow.classList.remove(hidden);
        } else {
            arrow.classList.add(hidden);
        }


    }

}

/**
 * 
 */
rtn.init = (braceCollection) => {

    arrow = document.querySelector('.arrow');
    backToTop = document.querySelector('.back-to-top');
    pagination = document.querySelector('.nav.pagination');
    popup = document.querySelectorAll('.popup');
    currentBraceCollection = braceCollection;

    let currentBrace = null,
        nextBrace = null;

    if (currentBraceCollection) {

        scroll = new smoothScroll(hashLinks, {
            speed: speed,
            easing: easing
        });



        // Listen for scroll events
        document.addEventListener('scrollStart', scrollEventHandler, false);
        document.addEventListener('scrollStop', scrollEventHandler, false);
        document.addEventListener('scrollCancel', scrollEventHandler, false);

        //event handlers
        arrow.querySelector('span').addEventListener('click', arrowEvent, false);
        window.addEventListener('scroll', scrollEventHandler, false);

        scrollEventHandler({ type: 'scrollStop' });


    }



}


module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/scroll-action.js